export const environment = {
  production: true,
  // BASE_URL: window["env"]["BASE_URL"],
  // OUTLOOK_URL: window["env"]["OUTLOOK_URL"],
  // CLIENT_ID: window["env"]["CLIENT_ID"],
  // AUTHORITY: window["env"]["AUTHORITY"],
  // REDIRECT_URI: window["env"]["REDIRECT_URI"],
  // POST_LOGOUT_REDIRECT_URI: window["env"]["POST_LOGOUT_REDIRECT_URI"],
  // SCOPES: window["env"]["SCOPES"],
  // REMINDER_MINUTES_BEFORE_START: window["env"]["REMINDER_MINUTES_BEFORE_START"]
  BASE_URL: "https://venaqi-backend-dev.onrender.com/ditto",
  OUTLOOK_URL: "https://graph.microsoft.com/v1.0/me/events",
  CLIENT_ID: "888b65fa-d550-4778-8d40-91e59488c7a2",
  AUTHORITY: "https://login.microsoftonline.com/common",
  REDIRECT_URI: "http://localhost:4200",
  POST_LOGOUT_REDIRECT_URI: "/",
  SCOPES: "user.read, calendars.readwrite",
  REMINDER_MINUTES_BEFORE_START: 15
};